import { createIcon } from '../icon'
import CheckOrderIcon from '../svg/CheckOrderIcon'

export const CheckOrderIconDefault = createIcon(CheckOrderIcon)
